
import React, { useMemo } from 'react'
import moment from 'moment'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import RestrictionTree from './RestrictionTree'
import { Link } from 'react-router-dom'
import { useProject } from '@/Hooks/UseProject'
import { useProgrammation } from '@/Hooks/UseProgrammation'

interface RowItem {
  taskId: string
  itemId: string
  family: string
  description: string
  content: string
  createdAt: string
  creator: string
  responsable?: any
  promiseDate?: string
  requiredDate?: string
  releaseDate?: string
  closeDate?: string
  days: number
  tree: string[]
}

interface RestrictionRowItemProps {
  item: RowItem
}

const RestrictionRowItem = (props: RestrictionRowItemProps) => {

  const { item } = props

  const { t } = useTranslation()

  const { openItem } = useProgrammation()

  const familiesOptions: any = {
    general: t('CONSTRAINT_CREATOR:FamilyGeneral'),
    coordination: t('CONSTRAINT_CREATOR:FamilyCoordination'),
    resource: t('CONSTRAINT_CREATOR:FamilyResource'),
    time: t('CONSTRAINT_CREATOR:FamilyTime'),
    space: t('CONSTRAINT_CREATOR:FamilySpace'),
    design: t('CONSTRAINT_CREATOR:FamilyDesign'),
    logistic: t('CONSTRAINT_CREATOR:FamilyLogistic'),
  }

  const popover = (
    <Popover id="restriction-popover">
      <Popover.Content>
        <RestrictionTree tree={item.tree} />
      </Popover.Content>
    </Popover>
  )

  const handleEditItem = async (item_data: any) => {

    openItem({
      item_id: item_data.itemId,
      noRedirect: true
    })
  }

  return (
    <tr>
      <td>
        <OverlayTrigger
          placement="bottom"
          overlay={popover}
          rootClose
          transition={false}
        >
          <span>
            {item.taskId}
          </span>
        </OverlayTrigger>
      </td>
      <td>
          <div style={{ cursor: 'pointer' }}
            onClick={() => handleEditItem(item)}
          >
            <span
              className={`restriction-family-badge restriction-family-badge-${item.family}`}
            >
              {familiesOptions[item.family]}
            </span>
            <div
              className="restriction-name"
            >
              {item.description}
            </div>
            <div>
              {item.content}
            </div>
          </div>
      </td>
      <td>
        {item.createdAt && moment(item.createdAt).format('DD/MM/YYYY')}
      </td>
      <td>{item.creator}</td>
      <td>{item.responsable?.name} {item.responsable?.surname}</td>
      <td>
        {item.promiseDate &&
          moment.utc(item.promiseDate).format('DD/MM/YYYY')}
      </td>
      <td>
        {item.requiredDate &&
          moment.utc(item.requiredDate).format('DD/MM/YYYY')}
      </td>
      <td>
        {item.releaseDate &&
          moment.utc(item.releaseDate).format('DD/MM/YYYY')}
      </td>
      <td>
        {item.closeDate &&
          moment.utc(item.closeDate).format('DD/MM/YYYY')}
      </td>
      <td className="text-center">{item.days}</td>
    </tr>
  )
}

export default RestrictionRowItem
